// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutoSaveFormController from "./auto_save_form_controller"
application.register("auto-save-form", AutoSaveFormController)

import AutoloadModalController from "./autoload_modal_controller"
application.register("autoload-modal", AutoloadModalController)

import BlankStateController from "./blank_state_controller"
application.register("blank-state", BlankStateController)

import DarkModeToggleController from "./dark_mode_toggle_controller"
application.register("dark-mode-toggle", DarkModeToggleController)

import HotkeyController from "./hotkey_controller"
application.register("hotkey", HotkeyController)

import LinkOverlayController from "./link_overlay_controller"
application.register("link-overlay", LinkOverlayController)

import LinkedSelectController from "./linked_select_controller"
application.register("linked-select", LinkedSelectController)

import MultiInputController from "./multi_input_controller"
application.register("multi-input", MultiInputController)

import NavigationController from "./navigation_controller"
application.register("navigation", NavigationController)

import StateController from "./state_controller"
application.register("state", StateController)

import ToggleFocusModeController from "./toggle_focus_mode_controller"
application.register("toggle-focus-mode", ToggleFocusModeController)

import UppyBaseController from "./uppy_base_controller"
application.register("uppy-base", UppyBaseController)
